/**
 * CTA Dropdowns
 * @param {HTMLElement} rootElement - The root element.
 * @return {void}
 *
 */

import NiceSelect from 'nice-select2';
const initCTADropdown = () => {
	// Initialize the country and store dropdowns with NiceSelect.
	const initCountryDropdowns = document.querySelectorAll( '[data-cookbook-country]' );
	if ( initCountryDropdowns ) {
		initCountryDropdowns.forEach( ( dropdown ) => {
			new NiceSelect( document.getElementById( dropdown.id ) );
		} );
	}

	const initStoreDropdowns = document.querySelectorAll( '[data-cookbook-stores]' );
	if ( initStoreDropdowns ) {
		initStoreDropdowns.forEach( ( dropdown ) => {
			new NiceSelect( document.getElementById( dropdown.id ) );
		} );
	}

	// Select the country dropdown
	const getCountryDropdowns = document.querySelectorAll( '[data-cookbook-country]' );

	// Hide all store dropdowns
	function hideAllStoreDropdowns( dropdownID ) {
		const hideStoreDropdowns = document.querySelectorAll( `div.${ dropdownID }` );
		hideStoreDropdowns.forEach( ( dropdown ) => {
			dropdown.classList.add( '!hidden' );
			dropdown.classList.remove( 'selected' );
		} );
	}

	// Show the store dropdown for the given countryquerySelector
	function showStoreDropdown( country ) {
		const dropdownID = country.dataset.cookbookDropdownid;
		const countrycode = country.dataset.cookbookCountrycode;
		const storeDropdown = document.querySelector( `div.rte-store-${ dropdownID }-${ countrycode }` );
		if ( storeDropdown ) {
			storeDropdown.classList.remove( '!hidden' );
			storeDropdown.classList.add( 'selected' );
		}
	}

	// Add an event listener to the stores dropdown
	const getStoreDropdowns = document.querySelectorAll( '[data-cookbook-stores]' );
	getStoreDropdowns.forEach( ( storeDropdown ) => {
		storeDropdown.addEventListener( 'change', ( event ) => {
			const selectedForm = event.target.closest( 'form.rte-pre-order' );
			const errorMessage = selectedForm.querySelector( '#rte-cookbook-error' );
			if ( errorMessage.classList.contains( 'flex' ) ) {
				errorMessage.classList.add( 'hidden' );
				errorMessage.classList.remove( 'flex' );
			}
		} );
	} );

	// Add an event listener to the country dropdown
	getCountryDropdowns.forEach( ( countryDropdown ) => {
		countryDropdown.addEventListener( 'change', ( event ) => {
			const selectedCountryStore = event.target.selectedOptions[ 0 ];
			if ( ! selectedCountryStore ) {
				return;
			}

			const selectedForm = event.target.closest( 'form.rte-pre-order' );
			const errorMessage = selectedForm.querySelector( '#rte-cookbook-error' );
			if ( errorMessage.classList.contains( 'flex' ) ) {
				errorMessage.classList.add( 'hidden' );
				errorMessage.classList.remove( 'flex' );
			}

			// Hide all store dropdowns.
			hideAllStoreDropdowns( event.target.id );

			// Show the store dropdown for the selected country.
			showStoreDropdown( selectedCountryStore );
		} );
	} );

	const submitBtns = document.querySelectorAll( '.rte-bookbook-submit' );
	submitBtns.forEach( ( submit ) => {
		submit.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			const selectedForm = event.target.closest( 'form.rte-pre-order' );
			const selectedCountry = selectedForm.querySelector( '.country-dropdown li.selected' );
			const selectedStore = selectedForm.querySelector( '.store-dropdown.selected li.selected' );
			const countryValue = selectedCountry?.getAttribute( 'data-value' );
			const storeValue = selectedStore?.getAttribute( 'data-value' );
			if ( ! countryValue || ! storeValue ) {
				const errorMessage = selectedForm.querySelector( '#rte-cookbook-error' );
				if ( errorMessage ) {
					errorMessage.classList.remove( 'hidden' );
					errorMessage.classList.add( 'flex' );
				}

				return;
			}

			// Open new window to display selected store.
			window.open( storeValue, '_blank' );

			const storeName = selectedStore.innerText;

			window.dataLayer = window.dataLayer || [];
			dataLayer.push( {
				event: 'gtm.linkClick',
				gtm: {
					elementUrl: storeValue,
					elementText: storeName,
					elementTarget: '_blank',
					willOpenInNewWindow: true,
				},
			} );

			const domain = new URL( storeValue );
			dataLayer.push( {
				event: 'click',
				eventModel: {
					link_text: storeName,
					link_url: storeValue,
					link_domain: domain.hostname.replace( 'www.', '' ),
					outbound: true,
					transport_type: 'beacon',
					event_callback() {
						window.open( storeValue, '_blank' );
					},
				},
			} );
		} );
	} );
};

export default initCTADropdown;
